import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { IAccount } from '../../../shared/models';
import { ACCOUNTS_ACTIONS } from '../actions/accounts.actions';
import { ActionReducer } from '@ngrx/store/src/models';
import { Action, createReducer, on } from '@ngrx/store';

export const ACCOUNTS_STATE_KEY = 'accounts';

export interface IAccountsState extends EntityState<IAccount> {
  loading: boolean;
  error: Error | null;
}

export const accountsAdapter: EntityAdapter<IAccount> = createEntityAdapter<IAccount>({
  selectId: (item) => item.accountId,
  sortComparer: (acct1, acct2) => acct1.accountName.localeCompare(acct2.accountName),
});

export const initialState: IAccountsState = accountsAdapter.getInitialState({
  loading: false,
  error: null,
});

const _accountsReducer: ActionReducer<IAccountsState> = createReducer<IAccountsState>(
  initialState,
  on(ACCOUNTS_ACTIONS.getAccounts, (state) => ({ ...state, loading: true })),
  on(ACCOUNTS_ACTIONS.getAccountsSuccess, (state, { payload }) =>
    accountsAdapter.setAll(payload, { ...state, loading: false }),
  ),
  on(ACCOUNTS_ACTIONS.getAccountsError, (state, { payload }) => ({ ...state, loading: false, error: payload })),
);

export const accountsReducer = (state: IAccountsState | undefined, action: Action): IAccountsState =>
  _accountsReducer(state, action);
